require('./styles.css');
import React from 'react';

export class PortfolioItem extends React.Component {
  render () {
    return (
      <article className="portfolio__item">
        { this.props.video && (
          <video muted autoPlay loop playsInline>
            <source media="(min-width: 800px)" src={this.props.video} type="video/mp4" />
            <source media="(max-width: 799px)" src={this.props.video.replace('.mp4', '-small.mp4')} type="video/mp4" />
          </video>
        )}
        { this.props.image && (
          <img src={this.props.image} />
        )}
        <div className="portfolio__item__text">
          { this.props.children }
        </div>
      </article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/portfolio-item/index.js